// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/box.js';

import { paths } from '../generated/box';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('box', Original, paths);
